import { Button } from "../Button"
import { ModalBody, ModalHeader, ModalPanel } from "../Modal"
import SuccessIcon from "../../assets/icons/success.svg"
import "./styles.scss"

export const AddNumberConfig = ({
  project = {},
  modalIsOpen,
  handleCloseModal,
  handleGenerateQRCode,
  loading,
  qrcode,
  successQR,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader title={`Configurar número: ${project?.name}`} closeModal={handleCloseModal} />
      <ModalBody className="modal-container-qrcode">
        <div className="modal-container-qrcode__body">
          <Button
            label="Gerar QRCode para acesso"
            handleClick={handleGenerateQRCode}
            isDisabled={loading || qrcode || successQR}
          />
          {successQR ? (
            <div className="modal-container-qrcode__add-number success">
              <div className="icon">
                <img src={SuccessIcon} alt="Success" />
              </div>
              <h1>Conectado</h1>
              <span>Para alteração do número de acesso, entre em contato conosco</span>
            </div>
          ) : qrcode ? (
            <div className="modal-container-qrcode__add-number">
              <span>Leia o QRCode em seu Whatsapp para conectar-se</span>
              <img src={qrcode} />
            </div>
          ) : (
            <></>
          )}
        </div>
      </ModalBody>
    </ModalPanel>
  )
}
